var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invite-share-bottom"},[_c('div',{staticClass:"btn-share",on:{"click":_vm.showShare}},[_c('img',{attrs:{"src":require("../../../../assets/images/parent_active/invite/ic_invite_gold.png")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }